"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log detailed error information for debugging
    console.error("Global error boundary caught:", {
      message: error.message,
      digest: error.digest,
      stack: error.stack,
      name: error.name,
    });
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center px-[7.5%] bg-gray-50">
      <div className="text-center max-w-2xl">
        <h1 className="text-4xl font-bold mb-4 text-gray-900">Oops!</h1>
        <h2 className="text-2xl font-semibold mb-4 text-gray-700">
          We didn't find what you're looking for
        </h2>
        <p className="mb-6 text-gray-600">
          Something went wrong while loading this page. This might be a temporary issue.
          Please try again or return to the homepage.
        </p>
        <div className="flex gap-4 justify-center">
          <button
            onClick={() => reset()}
            className="px-6 py-3 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
          >
            Try again
          </button>
          <a
            href="/"
            className="px-6 py-3 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition-colors"
          >
            Go to homepage
          </a>
        </div>
      </div>
    </div>
  );
}
